// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { isoDateSchema, maskedContactSchema } from '../_shared/primitives'

/**
 * Request do login unificado: só o identificador, e-mail OU CPF (o resolver decide no servidor). Sem roleId — papéis
 * derivam do resolver. No Portal 2.0 ninguém tem senha (spec 20261021-141500, AC-3): `.strict()` faz senha ou
 * protocolo no corpo virar 400, e não um campo ignorado em silêncio.
 */
export const loginRequestSchema = z
  .object({
    identifier: z.string().min(1),
  })
  .strict()
export type LoginRequest = z.infer<typeof loginRequestSchema>

const channelsSchema = z.object({
  sms: maskedContactSchema.optional(),
  whatsapp: maskedContactSchema.optional(),
  email: maskedContactSchema.optional(),
})

/**
 * Resposta 202 (alvo MFA_ALL: sempre que credencial OK). Apenas contatos mascarados — sem PII, sem roleId.
 * Transicional: papéis ainda sem flag MFA_ALL podem receber authSuccess(200) (ver auth/me.ts).
 */
export const loginMfaRequiredSchema = z.object({
  requireMFA: z.literal(true),
  mfaToken: z.string(),
  mfaExpiresAt: isoDateSchema,
  channels: channelsSchema,
  nextStep: z.literal('VALIDATE_CODE'),
})
export type LoginMfaRequired = z.infer<typeof loginMfaRequiredSchema>
